function setTimelineHeight(){

    const slider = document.querySelector('.timeline-story__interactive');

    if(!slider) return;


    const items = slider.querySelectorAll('.timeline-story__item');

    let maxHeight = 0;


    items.forEach(item => {

        const height = item.scrollHeight;

        if(height > maxHeight){

            maxHeight = height;

        }

    });


    slider.style.height = maxHeight + 'px';

}


window.addEventListener('load', setTimelineHeight);

window.addEventListener('resize', setTimelineHeight);

document.querySelectorAll('.timeline-story__item img').forEach(img => {

    img.addEventListener('load', setTimelineHeight);

});








document.addEventListener("DOMContentLoaded", function(){


document.querySelectorAll(".timeline-story").forEach(section=>{


const interactive = section.querySelector(
".timeline-story__interactive"
);


const years = section.querySelectorAll(
".timeline-story__year"
);


const items = section.querySelectorAll(
".timeline-story__item"
);


let activeIndex = 0;


function changeSlide(index){

    // Endlosschleife
    if(index < 0){
        index = years.length - 1;
    }

    if(index >= years.length){
        index = 0;
    }

    activeIndex = index;

    years.forEach(year=>{
        year.classList.remove("is-active");
    });

    years[index].classList.add("is-active");

    items.forEach(item=>{

        if(item.classList.contains("is-active")){

            item.classList.add("is-leaving");

            setTimeout(()=>{

                item.classList.remove("is-active");
                item.classList.remove("is-leaving");

            },700);

        }

    });

    items[index].classList.add("is-active");

    years[index].scrollIntoView({

        behavior:"smooth",
        inline:"center",
        block:"nearest"

    });

    setTimelineHeight();

}



//
// Klick auf Jahreszahl
//


years.forEach((year,index)=>{


year.addEventListener("click",()=>{

changeSlide(index);

});


});



//
// Drag / Swipe
//

let startX = 0;
let startY = 0;
let isDragging = false;

function start(clientX, clientY){

    startX = clientX;
    startY = clientY;
    isDragging = true;

    interactive.classList.add("is-dragging");
}

function end(clientX, clientY){

    if(!isDragging) return;

    const diffX = clientX - startX;
    const diffY = clientY - startY;

    isDragging = false;

    interactive.classList.remove("is-dragging");

    // Nur reagieren wenn überwiegend horizontal gewischt wurde
    if(Math.abs(diffX) < 50) return;
    if(Math.abs(diffY) > Math.abs(diffX)) return;

    if(diffX < 0){
        changeSlide(activeIndex + 1);
    }else{
        changeSlide(activeIndex - 1);
    }
}


// Pointer (Desktop + viele Mobile Browser)

interactive.addEventListener("pointerdown", e=>{
    start(e.clientX, e.clientY);
});

interactive.addEventListener("pointerup", e=>{
    end(e.clientX, e.clientY);
});

interactive.addEventListener("pointercancel", ()=>{
    isDragging = false;
    interactive.classList.remove("is-dragging");
});


// Touch (iOS / Android)

interactive.addEventListener("touchstart", e=>{

    const touch = e.touches[0];

    start(touch.clientX, touch.clientY);

}, {passive:true});


interactive.addEventListener("touchend", e=>{

    const touch = e.changedTouches[0];

    end(touch.clientX, touch.clientY);

}, {passive:true});

});

});
